import { gql } from '@/__generated__';

const CREATE_SMA_DEVICE_METRIC = gql(`#graphql
mutation CreateSmaDeviceMetric($input: CreateSmaDeviceMetricInput!, $scheduleInput: UpdateSmaScheduleInput) {
  createSmaDeviceMetric(input: $input, scheduleInput: $scheduleInput)
}
`);

export default CREATE_SMA_DEVICE_METRIC;
